import { render } from "./MfaVerifyView.vue?vue&type=template&id=805c055c&scoped=true"
import script from "./MfaVerifyView.vue?vue&type=script&lang=js"
export * from "./MfaVerifyView.vue?vue&type=script&lang=js"

import "./MfaVerifyView.vue?vue&type=style&index=0&id=805c055c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-805c055c"]])

export default __exports__